import styled from 'styled-components';
import { colors } from 'styles/colors';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  input {
    border-color: ${colors.stroke['sub-300']};
  }
`;

export const FormFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 26px;

  & > button {
    height: 33px;
  }
`;
